import _ from 'lodash';
import TaxDeductionService from 'web-core/src/tax-deduction-service';
import AuthService from 'web-core/src/auth-service';

export const REQUEST_TAX_PROFESSIONS = 'REQUEST_TAX_PROFESSIONS';
export const RECEIVE_TAX_PROFESSIONS = 'RECEIVE_TAX_PROFESSIONS';
export const ADD_TAX_PROFESSION = 'ADD_TAX_PROFESSION';
export const REMOVE_TAX_PROFESSION = 'REMOVE_TAX_PROFESSION';
export const SET_SELECTED_PROFESSIONS = 'SET_SELECTED_PROFESSIONS';
export const SET_TOKEN = 'SET_TOKEN';

const requestProfessions = () => ({
  type: REQUEST_TAX_PROFESSIONS,
});

const receiveProfessions = data => ({
  ...data,
  type: RECEIVE_TAX_PROFESSIONS,
});

export function addProfession(professionId) {
  return {
    type: ADD_TAX_PROFESSION,
    professionId,
  };
}

export function removeProfession(professionId) {
  return {
    type: REMOVE_TAX_PROFESSION,
    professionId,
  };
}

export function setSelectedProfessions(professionIds) {
  return {
    type: SET_SELECTED_PROFESSIONS,
    professionIds,
  };
}

const setToken = id => ({
  token: id,
  type: SET_TOKEN,
});

export function fetchProfessionsIfNeeded(force = false) {
  return (dispatch, getState, { apiClient }) => {
    const professions = getState().professions;
    if (!force && _.get(professions, 'content.length')) {
      return Promise.resolve(getState().professions);
    }

    dispatch(requestProfessions());
    const svc = new TaxDeductionService({ client: apiClient });
    return svc.getProfessions().then((response) => {
      dispatch(receiveProfessions(response));
      return response;
    });
  };
}

export function fetchPersonalizedProfessions() {
  return (dispatch, getState, { apiClient }) => {
    dispatch(requestProfessions());
    const authService = new AuthService({ client: apiClient });
    return authService
      .getToken()
      .then((token) => {
        dispatch(setToken(token));
        const taxSvc = new TaxDeductionService({ client: apiClient });
        return taxSvc.getPersonalizedProfessions(token);
      })
      .then((response) => {
        dispatch(receiveProfessions(response));
        return response;
      });
  };
}

// assumes logged in
export function saveProfessions(professionIds) {
  return (dispath, getState, { apiClient }) => {
    const authService = new AuthService({ client: apiClient });
    return authService.getToken().then((token) => {
      const taxSvc = new TaxDeductionService({ client: apiClient });
      return taxSvc.postProfessions(professionIds, token);
    });
  };
}
